var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-desktop desktop"},[_vm._t("overlay"),_vm._t("header"),_c('div',{staticClass:"desktop__main-container",attrs:{"role":"main"}},[_vm._t("sidepanel"),_c('ODMap')],2),_vm._t("footer"),_vm._t("modal")],2)}
var staticRenderFns = []

export { render, staticRenderFns }